import { featureFlagController, WEBAPP_UI_IMPROVEMENTS } from '@/next/utils/featureFlags';
import {
  TabsContent as TabsContentV1,
  TabsContentV2,
  TabsList as TabsListV1,
  TabsListV2,
  TabsTrigger as TabsTriggerV1,
  TabsTriggerV2,
  Tabs as TabsV1,
  TabsV2,
} from '@skand/ui';
import { forwardRef } from 'react';

const TabsTriggerV1Override = forwardRef<
  React.ElementRef<typeof TabsTriggerV1>,
  React.ComponentPropsWithoutRef<typeof TabsTriggerV1>
>((props, ref) => <TabsTriggerV1 ref={ref} style={{ paddingTop: 0 }} {...props} />);
TabsTriggerV1Override.displayName = 'TabsTriggerV1Override';

export const useTabsComponents = () => {
  const isWebappUiImprovementsEnabled =
    featureFlagController.useTreatment(WEBAPP_UI_IMPROVEMENTS) === 'on';
  const Tabs = isWebappUiImprovementsEnabled ? TabsV2 : TabsV1;
  const TabsList = isWebappUiImprovementsEnabled ? TabsListV2 : TabsListV1;
  const TabsTrigger = isWebappUiImprovementsEnabled ? TabsTriggerV2 : TabsTriggerV1Override;
  const TabsContent = isWebappUiImprovementsEnabled ? TabsContentV2 : TabsContentV1;
  return { Tabs, TabsList, TabsTrigger, TabsContent };
};
